import { Localization } from "@viamap/viamap2-common"
import { useEffect, useState } from "react"
import { GlassInputControl, GlassTextInputTransformer } from "src/components/GlassInput"

interface JobIntervalParams {
   enabled: boolean;
}

export function JobModuleIntervalInputs(props: { jobIntervalParams: JobIntervalParams | undefined, onChange: (value: any) => void }) {
   const [state, setState] = useState<any>({})

   const fullParams = {
      enabled: {
         type: 'checkbox',
         da: 'Aktiver gentagende job',
         en: 'Activate recurrent job',
         default: false
      },
      minTime: {
         type: 'number',
         da: 'Kør hver',
         en: 'Run every',
         default: 5,
         min: 1,
         max: 60
      }
   };

   useEffect(() => {
      const result = { ...state };
      if (result.enabled && result.minTime === undefined) {
         result.minTime = fullParams.minTime.default;
      }
      props.onChange(result)
   }, [state])

   if (props?.jobIntervalParams === undefined) {
      return <></>
   }

   function handleStateChange(key: string, value: any) {
      setState((prevState: any) => {
         const newState = {
            ...prevState,
            [key]: value
         };

         if (key === 'enabled' && value === true && newState.minTime === undefined) {
            newState.minTime = fullParams.minTime.default;
         }

         return newState;
      })
   }

   return (
      <GlassTextInputTransformer label={fullParams.enabled[Localization.getLanguage()] || 'enabled'}>
         <div style={{ display: 'flex', alignItems: 'center', gap: '16px', width: '100%' }}>
            <div style={{ width: '10%', justifyContent: 'flex-start' }}>
               <GlassInputControl>
                  <input
                     type="checkbox"
                     checked={state.enabled || false}
                     onChange={(e) => handleStateChange('enabled', e.target.checked)}
                  />
               </GlassInputControl>
            </div>
            {state.enabled && (
               <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, justifyContent: 'flex-end' }}>
                  <label style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>
                     {fullParams.minTime[Localization.getLanguage()] || 'minTime'}:
                  </label>
                  <GlassInputControl>
                     <input
                        value={state.minTime || fullParams.minTime.default || 0}
                        onChange={(e) => handleStateChange('minTime', e.target.valueAsNumber)}
                        type="number"
                        min={fullParams.minTime.min}
                        max={fullParams.minTime.max}
                        style={{ paddingRight: '24px' }}
                     />
                     <span style={{
                        position: 'absolute',
                        right: '16px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#666',
                        fontSize: '12px',
                        pointerEvents: 'none'
                     }}>
                        min
                     </span>
                  </GlassInputControl>
               </div>
            )}
         </div>
      </GlassTextInputTransformer>
   )
}








